import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import SubMenu from './SubMenu';

import { BsArrowLeftShort, BsListUl, BsFillPersonLinesFill, BsCalendar3, BsChatLeftText, BsFillPersonBadgeFill, BsFillDiagram3Fill, BsPersonCircle, BsClipboardPlus } from "react-icons/bs";
const menuData = [
    {
        name: 'ÖĞRENCİ',
        url: null,
        submenu: null,
        roles: ["Öğrenci"]
    },
    {
        name: 'Hesabım',
        url: '/ogrenci-hesap',
        icon: <BsPersonCircle />,
        submenu: null,
        roles: ["Öğrenci"]
    },
    {
        name: 'Başvurularım',
        url: '/ogrenci-basvurular',
        icon: <BsListUl />,
        submenu: null,
        roles: ["Öğrenci"]
    },
    {
        name: 'Yeni Başvuru',
        url: '/yeni-basvuru',
        icon: <BsClipboardPlus />,
        submenu: null,
        roles: ["Öğrenci"]
    },
    {
        name: 'DANIŞMAN',
        url: null,
        submenu: null,
        roles: ["Danışman"]
    },
    {
        name: 'Gelen Başvurular',
        url: '/gelen-basvurular',
        icon: <BsListUl />,
        submenu: null,
        roles: ["Danışman"]
    },
    {
        name: 'YÖNETİCİ',
        url: null,
        submenu: null,
        roles: ["Yönetici"]
    },
    {
        name: 'Gelen Tüm Başvurular',
        url: '/tum-basvurular',
        icon: <BsListUl />,
        submenu: null,
        roles: ["Yönetici"]
    },
    {
        name: 'Öğrenci Listesi',
        url: '/ogrenci-listesi',
        icon: <BsFillPersonLinesFill />,
        submenu: null,
        roles: ["Yönetici"]
    },
    {
        name: 'Dönem İşlemleri',
        url: '/donem-islemleri',
        icon: <BsCalendar3 />,
        submenu: null,
        roles: ["Yönetici"]
    },
    {
        name: 'Tanımlar',
        url: '/tanimlar',
        icon: <BsChatLeftText />,
        submenu: null,
        roles: ["Yönetici"]
    },
    {
        name: 'Danisman Tanımları',
        url: '/danisman-tanimlari',
        icon: <BsFillPersonBadgeFill />,
        submenu: null,
        roles: ["Yönetici"]
    },
    {
        name: 'Sistem Ayarları',
        url: '/sistem-ayarlari',
        icon: <BsFillDiagram3Fill />,
        submenu: null,
        roles: ["Yönetici"]
    },
    // {
    // 	name: 'Hizmetler',
    // 	url: '/hizmetler',
    // 	icon: <BiAlbum />,
    // 	submenu: [
    // 		{
    // 			name: 'Web Tasarım',
    // 			url: '/hizmetler/web-tasarim',
    // 			submenu: null,
    // 		},
    // 		{
    // 			name: 'Mobil Uygulama',
    // 			url: '/hizmetler/mobil-uygulama',
    // 			submenu: [
    // 				{
    // 					name: 'Web Tasarım',
    // 					url: '/hizmetler/web-tasarim',
    // 					submenu: null,
    // 				},
    // 				{
    // 					name: 'Mobil Uygulama',
    // 					url: '/hizmetler/mobil-uygulama',
    // 					submenu: null,
    // 				},
    // 			]
    // 		},
    // 	]
    // },

];


const Sidebar = (props) => {

    const reduxData = useSelector((state)=>state.auth)

    return (
        <div className='relative'>
            <div className={classNames({
                "flex w-64 z-50 flex-col fixed inset-y-0 border-r border-slate-200 ": props.isOpenSidebar === true,
                "hidden": props.isOpenSidebar === false
            })}>
                <div className="flex flex-col flex-grow bg-white  overflow-y-auto rounded-tl-2xl rounded-bl-2xl">
                    <div className='flex h-24 flex-shrink-0 w-full items-center justify-between pl-4 pr-0' style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/images/doku.png'})`, backgroundRepeat: 'repeat-x' }}>
                        <img src={process.env.PUBLIC_URL + '/images/odu-yatay-color.png'} className='h-14' alt='' />
                        <button className='md:hidden' onClick={() => { props.setIsOpenSidebar(!props.isOpenSidebar) }} ><BsArrowLeftShort className='text-4xl text-slate-500 hover:text-slate-400' /></button>
                    </div>
                    <div className='overflow-y-auto scrollbar-thin scrollbar-track-slate-200 scrollbar-thumb-slate-300 hover:scrollbar-thumb-slate-400'>
                        <div className='relative h-full w-full'>
                            <div className='px-4 pb-8'>
                                <SubMenu data={menuData} />
                            </div>
                        </div>
                    </div>
                    <div className='mt-auto mb-4 py-2 mx-2   rounded-lg px-4 bg-slate-100  text-center flex items-center justify-between text-slate-500'>
                        <div className='text-left'>
                            <h1 className='font-semibold text-sm'>{
                                reduxData ? reduxData.userName : ''
                            }</h1>
                            <div className='text-xs'>{
                                reduxData ? reduxData.userEnstituName : ''
                            }</div>
                            <span className='text-xs'>{
                                reduxData ? reduxData.userRole : ''
                            }</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
